import { Line, Scatter, mixins } from "vue-chartjs";
import annotation from "chartjs-plugin-annotation";

export default {
  extends: Scatter,
  mixins: [mixins.reactiveProp],
  props: ["chartData"],
  data() {
    return {
      options: {
        responsive: true, 
        scales: { 
          xAxes: [
            { 
              type: 'time', 
              distribution: 'linear' 
            }
          ] 
        },
        showTooltips: true,
        onAnimationComplete: function() {
          this.showTooltip([this.chartdata[0]], true);
          // this.showTooltip(this.chartdata[0].points, true);
        },
        tooltipEvents: [],
        tooltips: {
            mode: 'index',
            intersect: true,
            bodyFontSize: 18,
            enabled: true
        },
        // plugins: {
          annotation: {
            annotations: [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: 0,
              borderColor: 'rgb(75, 192, 192)',
              borderWidth: 4,
              label: {
                enabled: false,
                content: 'Test label'
              }
            }]
          }
        // }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  }
};
